export default "__VITE_ASSET__CAbhj3i1__"